module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921052649_T.79f4bc02.jpg";